import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import { StoreProvider } from './store'
import './styles.css'

/** Injected by Vite at build time — see vite.config.ts. */
declare const __BUILD_ID__: string

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <StoreProvider>
      <App />
    </StoreProvider>
  </StrictMode>
)

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    // The build id in the URL is what makes the browser fetch and install a new worker on
    // each deploy. Without it the file is byte-identical forever and the old worker keeps
    // serving an app shell whose asset filenames no longer exist.
    navigator.serviceWorker.register(`/sw.js?v=${__BUILD_ID__}`).catch(() => {
      // Offline support is a bonus; the app works fine without it.
    })
  })
}
